export default __webpack_public_path__ + "static/media/bamboo.05accedd.png";